import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_the_facs_waste_disposal_practices_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'are_the_facs_waste_disposal_practices_in_line_w_legal_reqs',
  name: "Are the facility's waste disposal practices in line with legal requirements?",
  description:
    'Waste refers to solid waste, liquid waste and hazardous waste. \r\r\n\r\r\nConsult applicable legal requirements. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-gen-7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13480,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
